import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center bg-background-50 px-6">
      <div
        className="w-16 h-16 bg-primary-500 mb-8"
        style={{ clipPath: 'polygon(50% 0%, 100% 100%, 0% 100%)' }}
      />
      <div className="font-mono-tech text-xs tracking-widest text-foreground-500 mb-4">
        ERROR · 404
      </div>
      <h1 className="font-heading text-4xl md:text-6xl font-semibold text-foreground-950 tracking-tight text-center">
        Page not found
      </h1>
      <p className="mt-4 text-foreground-600 text-center max-w-md">
        您訪問的頁面可能已被移動或不存在。
      </p>
      <Link
        to="/"
        className="mt-10 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-950 hover:bg-primary-500 hover:text-foreground-950 text-background-50 text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
      >
        <i className="ri-arrow-left-line text-base w-4 h-4 flex items-center justify-center" />
        Return home
      </Link>
    </div>
  );
}